import {
    Directive,
    HostListener,
    ElementRef,
    Renderer2,
    Input
} from '@angular/core';

@Directive({
    selector: '[appParallax]'
})
export class ParallaxDirective {

    private x = 0;
    private y = 0;

    @Input()
    set appParallax([x = this.x, y = this.y]) {
        this.x = x;
        this.y = y;
    }

    @Input()
    set appParallaxX(value) {
        this.x = value;
    }

    @Input()
    set appParallaxY(value) {
        this.y = value;
    }

    @HostListener('window:mousemove', ['$event']) onMousemove($event) {
        const hw = window.innerWidth / 2;
        const px = hw / 100;
        const ox = ($event.screenX - hw) / px;

        const hh = window.innerHeight / 2;
        const py = hh / 100;
        const oy = ($event.screenY - hw) / px;

        this._renderer.setStyle(this._el.nativeElement, 'transform', `translateX(${ this.x * ox }px) translateY(${ this.y * oy }px)`);
    }

    constructor(
        private _el: ElementRef,
        private _renderer: Renderer2
    ) {
    }

}
